module.exports = __webpack_public_path__ + "img/company_banner.c95367d8.jpg";